<template>
  <div class="data-table-th-90">
    <el-tooltip placement="top">
      <div slot="content">リスト名を変更</div>
      <el-button type="default" @click="openCreateList()" size="small" style="padding: 9px 10px">
        <i class="el-icon-edit"></i>
      </el-button>
    </el-tooltip>
    <el-tooltip placement="top">
      <div slot="content">リストを削除</div>
      <el-button @click="deleteList(list.list_name, list.list_id, index)" type="default" size="small" style="padding: 9px 10px">
        <i class="el-icon-delete"></i>
      </el-button>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "listManageButton",
  props: ["list", "index"],
  data() {
    return {};
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    activate() {
      return this.$store.state.activate;
    },
  },
  methods: {
    openCreateList() {
      this.$emit("openCreateList", 'change', this.list.list_name, this.list.list_id, this.index);
    },
    deleteList(name, id, index) {
      this.$emit("deleteList", name, id, index);
    },
  },
  filters: {
    
  },
};
</script>

<style></style>
